/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from 'react';
import { withStyles, createTheme, ThemeProvider } from '@material-ui/core/styles'

import {Button, CircularProgress, Divider, IconButton, Paper, Typography} from '@material-ui/core'

import FlexForm from '../FlexForm/FlexForm';

import Action from '../../fluid/Actions/ActionFactory';

let equal = require('deep-equal')

const blue_theme = createTheme({
    palette: {
        primary: {
          main: '#2296f3',
        },
        secondary: {
            main: '#dc014e',
        }
      },
})

const styles = theme => ({

})

class Prevent extends Component {
    state = {
        ic_name : null,
        wv_fields : [],
        field_form : [],
        field_values : {},
        results : [],
        show_form_input : true,
        show_results : true,
        params_loaded : false,
        loading_results : false,
        results_loaded : false,
        results_error : false
    }

    componentDidMount () {
        this.setParams()
    }

    componentDidUpdate (prevProps) {
        if (!equal(prevProps.params, this.props.params)) {
            this.setParams()
        }
    }

    setParams = () => {
        let params = {
            ic_name : null,
            wv_fields : [],
            field_form : [],
            field_values : {},
            show_form_input : true,
            show_results : true,
            result_index : 0
        }

        let default_params = this.loadDefaultParams()
        let query_params = this.loadQueryParams()

        console.log('Prevent :: Query Params : ', query_params)

        params.ic_name = default_params.ic_name
        params.wv_fields = default_params.wv_fields
        params.field_form = default_params.field_form
        params.show_form_input = default_params.show_form_input
        params.show_results = default_params.show_results

        let field_values = params.wv_fields.map(field => {
            let value = ''
            let query_keys = Object.keys(query_params)
            if (query_keys.length > 0) {
                let field_index = query_keys.findIndex(key => key === field.name)
                if (field_index !== -1) {
                    value = decodeURIComponent(query_params[field.name])
                }
            }

            return [field.name, value]
        })

        params.field_values = Object.fromEntries(field_values)
        params.field_form = this.preloadFieldForm(params.field_values, params.field_form)

        this.setState({...this.state, ...params, params_loaded : true}, () => {
            console.log('Prevent :: Params Loaded : ', this.state)
            if (this.formValidation()) {
                this.getResults()
            }
        })
    }

    loadQueryParams = () => {
        let params = this.props.params
        console.log("params :", this.props.params)
        let params_with_values = Object.entries(params).filter(entry => entry[1] !== null)
        console.log("params_with_values:", params_with_values)
        return Object.fromEntries(params_with_values) 
    }

    loadDefaultParams = () => {
        let routes = JSON.parse(sessionStorage.getItem('ui_routes')).drawer
        let op_section = routes.find(section => section.id === 'operations')
        let dqm_section = op_section.screens.find(section => section.id === 'dqm')
        let prevent_section = dqm_section.screens.find(section => section.id === 'prevent')
        let prevent_screen = prevent_section.screens.find(route => route.route === this.props.location.pathname)
        let params = prevent_screen.default_params
        console.log("Default Params in Config : ", params)
        let params_with_values = params !== null ? Object.entries(params).filter(entry => entry[1] !== null) : []
        return Object.fromEntries(params_with_values) 
    }

    getResults = () => {
        this.setState({...this.state, loading_results : true, results_loaded : false, results_error : false, result_index : 0}, () => {
            Action('http_request', {
                url : '/sainapse/irc/search',
                method : 'post',
                data : {
                    ic_name : this.state.ic_name,
                    query : [this.state.field_values]
                }
            }).then(res => {
                let duplicates = res.data.result.Result.duplicates[0].dup_records
                this.setState({...this.state, results : duplicates, loading_results : false, results_loaded : true, results_error : false, result_index : 0})
            }).catch(err => {
                this.setState({...this.state, results : [], loading_results : false, results_loaded : true, results_error : true, result_index : 0})
            })
        })
    }

    getIDforBindingKey = (binding_key, form) => {
        let id_list = form.map(field => field.id)
        let binding_key_list = form.map(field => {
            let component_params = field.component_params
            let binding_key = component_params.find(param => param.name === 'binding_key').value.text
            return binding_key
        })
        
        let binding_key_index = binding_key_list.findIndex(b_key => b_key === binding_key)
        if (binding_key_index !== -1) {
            return id_list[binding_key_index]
        } else {
            return null
        }
    }

    preloadFieldForm = (field_values, field_form) => {
        let field_keys = Object.keys(field_values)

        field_keys.forEach(field => {
            let field_id = this.getIDforBindingKey(field, field_form)
            let field_index = field_form.findIndex(field => field.id === field_id)

            if (field_index !== -1) {
                field_form[field_index].value.text = field_values[field]
            }
        })

        return field_form
    }

    updateFieldForm = (form) => {
        let field_values = form.map(field => {
            let arr = []
            arr.push(field.component_params.find(param => param.name === 'binding_key').value.text)
            arr.push(field.value.text)
            return arr
        })

        field_values = Object.fromEntries(field_values)
        this.setState({...this.state, field_form : form, field_values : field_values}, () => console.log('Prevent :: Test Record Form Update : ', this.state))
    }

    formValidation = () => {
        let values = Object.values(this.state.field_values)
        console.log('Prevent :: Form Validation : Values : ', values)
        let filtered_values = values.filter(val => val !== null && val !== '')
        console.log('Prevent :: Form Validation : Filtered Values : ', filtered_values)
        if (filtered_values.length !== values.length) {
            return false
        } else {
            return true
        }
    }


    renderForm = () => {
        return (
            <div style = {{width :'50%', padding : '10px'}}>
                <FlexForm 
                    key = 'test_record'
                    config = {this.state.field_form} 
                    fields_in_scope = {[]} 
                    update_parent = {(form) => this.updateFieldForm(form)} 
                    submit = {(form) =>  this.submitFieldForm(form)} 
                    grid_element_width = "20%"
                    drl_url = {''}
                    ic_name = {''}
                    on_open = {false}
                    show_attachment = {false}
                />
                <Button
                    onClick = {this.getResults}
                    disabled = {!this.formValidation()}
                    style = {{margin : '10px'}}
                    variant='contained'
                    color = 'primary'
                >Find Duplicates</Button>
            </div>
        )
    }

    navigateRecords = (direction) => {
        if (direction === 'next') {
            this.setState({...this.state, result_index : this.state.result_index + 1})
        } else {
            this.setState({...this.state, result_index : this.state.result_index - 1})
        }
    }

    renderButtons = () => {
        if (this.state.results.length > 1) {
            if (this.state.result_index === this.state.results.length - 1) {
                return (
                    <div style = {{width : '100%', display : 'flex', flexDirection : 'row'}}>
                        <Button
                            onClick={() => this.navigateRecords('previous')}
                            color = 'primary'
                        >Previous</Button>
                        <div style = {{flexGrow : 1}}></div>
                    </div>
                )
            } else if (this.state.result_index === 0) {
                return (
                    <div style = {{width : '100%', display : 'flex', flexDirection : 'row'}}>
                        <div style = {{flexGrow : 1}}></div>
                        <Button
                            onClick={() => this.navigateRecords('next')}
                            color = 'primary'
                        >Next</Button>
                    </div>
                )
            } else {
                return (
                    <div style = {{width : '100%', display : 'flex', flexDirection : 'row'}}>
                        <Button
                            onClick={() => this.navigateRecords('previous')}
                            color = 'primary'
                        >Previous</Button>
                        <div style = {{flexGrow : 1}}></div>
                        <Button
                            onClick={() => this.navigateRecords('next')}
                            color = 'primary'
                        >Next</Button>
                    </div>
                )
            }
        }
    }

    renderRecord = (index) => {
        //let record = this.state.results[this.state.result_index].wv_field_list
        let record = this.state.results[index].wv_field_list
        console.log('Prevent :: Rendering Record : ', record)
        let keys = Object.keys(record)
        console.log('Prevent :: Rendering Record Keys: ', keys)
        let values = Object.values(record)
        console.log('Prevent :: Rendering Record Values: ', values)
        return (
            <Paper style = {{marginTop : '10px', padding : '10px'}}>
                <Typography>{'Record ' + (index + 1)}</Typography>
                <Divider style = {{marginTop : '5px', marginBottom : '5px'}}/>
                {keys.map((key, i) => {
                    return (
                        <div style = {{marginBottom : '10px'}}>
                            <Typography variant = 'subtitle2'>{key}</Typography>
                            <Typography variant = 'body1'>{values[i]}</Typography>
                        </div>
                    )
                })}
            </Paper>
        )
    }

    renderRecords = () => {
        return (
            <div>
                {this.state.results.map((record, i) => {
                    return this.renderRecord(i)
                })}
            </div>
        )
    }

    renderResults = () => {
        if (this.state.results_loaded) {
            if (this.state.results_error) {
                return (
                    <div style = {{flexGrow : 1, padding : '10px', display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center', border : '1px solid rgba(0,0,0,0.12)'}}>
                        <Typography variant = 'caption' color = 'secondary'>Error fetching duplicates.</Typography>
                    </div>
                )
            } else {
                if (this.state.results.length === 0) {
                    return (
                        <div style = {{flexGrow : 1, padding : '10px', display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center', border : '1px solid rgba(0,0,0,0.12)'}}>
                            <Typography variant = 'caption'>No duplicates found</Typography>
                        </div>
                    )
                } else {
                    return (
                        <div style = {{flexGrow : 1, border : '1px solid rgba(0,0,0,0.12)'}}>
                            <Paper square style = {{width : '100%', height : '50px', padding : '10px', display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                                <Typography variant = 'button'>Duplicates</Typography>
                            </Paper>
                            <div style = {{padding : '10px'}}>
                                {/* <Typography style = {{marginBottom : '10px'}} variant = 'caption'>{'Showing ' + (this.state.result_index + 1) + ' of ' + this.state.results.length + ' duplicate records'}</Typography> */}
                                <Typography style = {{marginBottom : '10px'}} variant = 'caption'>{'Showing ' + this.state.results.length + ' duplicate records'}</Typography>
                                <Divider style = {{marginTop : '5px', marginBottom : '5px'}}/>
                                {/* {this.renderButtons()} */}
                                {this.renderRecords()}
                            </div>
                        </div>
                    )
                }
            }
         } else if (this.state.loading_results) {
            return (
                <div style = {{flexGrow : 1, padding : '10px', display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center', border : '1px solid rgba(0,0,0,0.12)'}}>
                    <CircularProgress variant='indeterminate' color = 'primary'/>
                </div>
            )
        } else {
            return (
                <div style = {{flexGrow : 1, padding : '10px', display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center', border : '1px solid rgba(0,0,0,0.12)', overflow : 'auto'}}>
                    <Typography variant = 'caption'>Input the values and hit search to get results.</Typography>
                </div>
            )
        }
    }

    render() { 
        return (
            <ThemeProvider theme = {blue_theme}>
                <div style = {{width : '100vw', height : '100%', display : 'flex', flexDirection : 'row'}}>
                    {this.state.params_loaded && this.state.show_form_input && this.renderForm()}
                    {this.state.params_loaded && this.state.show_results && this.renderResults()}
                </div>
            </ThemeProvider>
        );
    }
}
 
export default withStyles(styles)(Prevent);